import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkUpdateRestrictedPayoutsActions from "../../store/actions/BulkUpdateRestrictedPayouts";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const RestrictedPayoutsBulkUploadDashboard = ({ getBulkUploadUrl }) => {
  const filterTypes = ["ADD", "DELETE"];
  const filterTypeSampleCsvUrlMap = {
    ADD: "/sample/restricted_payout_add.csv",
    DELETE: "/sample/restricted_payout_delete.csv",
  };

  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="RestrictedPayoutsBulkUploadBtn"
      uploadUrl="/driver-accounting/bulk-update-restricted-payouts"
      filename="restricted_payouts"
      id="BulkUpdateRestrictedPayoutsModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Bulk Update Restricted Payouts"
      getUploadUrl={getBulkUploadUrl}
      closeUrl={"/"}
      filterTypes={filterTypes}
      filterTypeSampleCsvUrlMap={filterTypeSampleCsvUrlMap}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getBulkUploadUrl: bindActionCreators(
      BulkUpdateRestrictedPayoutsActions.getUploadUrl,
      dispatch
    ),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(RestrictedPayoutsBulkUploadDashboard);
